import React, { useState, useEffect } from 'react'
import DatePicker from 'aldoo-ra/DatePicker'
import Typography from 'aldoo-ra/Typography'
import { XMarkIcon } from '@heroicons/react/24/outline'

const PublishPlugin = ({ editor, onClose }) => {
  const [publishData, setPublishData] = useState({
    status: 'draft',
    publishDate: '',
    slug: '',
  })

  useEffect(() => {
    // Load existing publish data from page content
    if (editor.content) {
      // Extract slug from link if it exists
      const link = editor.content.link?.[0]
      const linkContent = link?.content || link
      const existingSlug = linkContent?.url || editor.content.slug || editor.content.id || ''

      setPublishData({
        status: editor.content.status || 'draft',
        publishDate: editor.content.publish_date || '',
        slug: existingSlug,
      })
    }
  }, [editor.pageId])

  const handleChange = (field, value) => {
    const newData = { ...publishData, [field]: value }
    setPublishData(newData)

    // Update page content directly
    if (field === 'status') {
      editor.updateContent({ status: value })
    } else if (field === 'publishDate') {
      editor.updateContent({ publish_date: value })
    } else if (field === 'slug') {
      // Store slug temporarily - will be converted to Link on save
      editor.updateContent({ slug: value })
    }
  }

  const getStatusLabel = (status) => {
    return status.charAt(0).toUpperCase() + status.slice(1)
  }

  return (
    <div className="flex flex-col h-full">
      {/* Content */}
      <div className="flex-1 overflow-y-auto p-6 relative">
        <button
          onClick={onClose}
          className="absolute top-6 right-6 p-1.5 rounded hover:bg-admin_neutral_1/50 text-admin_text_secondary hover:text-admin_error transition-colors z-10"
        >
          <XMarkIcon className="w-5 h-5" />
        </button>
        <div className="max-w-3xl mx-auto space-y-6">
        <div>
          <Typography variant="admin_label" className="mb-3">
            Status
          </Typography>
          <div className="grid grid-cols-3 gap-3">
            {['draft', 'scheduled', 'published'].map(status => (
              <button
                key={status}
                onClick={() => handleChange('status', status)}
                className={`px-4 py-3 rounded-lg border transition-all flex items-center justify-center ${
                  publishData.status === status
                    ? 'border-admin_primary bg-admin_primary/10 text-admin_primary font-semibold shadow-sm'
                    : 'border-admin_bordered text-admin_text_secondary hover:border-admin_primary/50 hover:bg-admin_neutral_1/30'
                }`}
              >
                {getStatusLabel(status)}
              </button>
            ))}
          </div>
        </div>

        {publishData.status === 'scheduled' && (
          <div>
            <Typography variant="admin_label" className="mb-3">
              Publish Date & Time
            </Typography>
            <DatePicker
              variant="admin"
              value={publishData.publishDate ? new Date(publishData.publishDate) : null}
              onChange={(date) => handleChange('publishDate', date?.toISOString() || '')}
              dateFormat="MMM DD, YYYY"
            />
            <Typography variant="admin_txt1_dim" className="text-xs mt-2">
              Schedule when this page should be published
            </Typography>
          </div>
        )}
        </div>
      </div>
    </div>
  )
}

export default PublishPlugin
